/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingBaseStockQuantityDetails } from '../../models/thermoforming-base-stock-quantity-details';

export interface MgmtThermoformingBaseStockControllerGetQuantityDetails$Params {
  id: number;
}

export function mgmtThermoformingBaseStockControllerGetQuantityDetails(http: HttpClient, rootUrl: string, params: MgmtThermoformingBaseStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBaseStockQuantityDetails>> {
  const rb = new RequestBuilder(rootUrl, mgmtThermoformingBaseStockControllerGetQuantityDetails.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingBaseStockQuantityDetails>;
    })
  );
}

mgmtThermoformingBaseStockControllerGetQuantityDetails.PATH = '/api/mgmt/thermoforming-base-stock/{id}/quantity-details';
